import { render } from "./BranchSection.vue?vue&type=template&id=40d94835&scoped=true"
import script from "./BranchSection.vue?vue&type=script&lang=js"
export * from "./BranchSection.vue?vue&type=script&lang=js"

import "./BranchSection.vue?vue&type=style&index=0&id=40d94835&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d94835"]])

export default __exports__